//FORM VALIDATION
const nameInput = document.querySelector('.wpcf7-form-control.contact-form__input--name');
const emailInput = document.querySelector('.wpcf7-form-control.contact-form__input--email');
const checkBox = document.querySelector('[name="contact-acceptance"]');
const submitBtn = document.querySelector('.wpcf7-form-control.contact-form__submit');


function formValidation() {
	if (!submitBtn || !nameInput || !emailInput || !checkBox) return;

	submitBtn.disabled = true;

	function isEmailValid(email) {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	function isNameValid(name) {
		const nameRegex = /^[A-Za-z]+$/;
		return nameRegex.test(name);
	}

	function validateInputs() {
		const name = nameInput.value.trim();
		const email = emailInput.value.trim();
		const checkboxChecked = checkBox.checked;
	
		if ((isNameValid(name) && isEmailValid(email)) && checkboxChecked) {
			submitBtn.disabled = false;
		} else {
			submitBtn.disabled = true;
		}
	}

	nameInput.addEventListener('input', validateInputs);
	emailInput.addEventListener('input', validateInputs);

	checkBox.addEventListener('change', (event)=> {
		event.stopPropagation();
		validateInputs();
	});
}
formValidation();

// COLLAPSE
document.querySelectorAll('.js-collapse-btn').forEach(item => {
	item.addEventListener('click', ()=> {
		item.classList.toggle('is-active');

		const collapse_text = item.nextElementSibling;

		if (collapse_text.classList.contains('js-collapse-text')) {
			collapse_text.classList.toggle('is-active');
			collapse_text.style.maxHeight = collapse_text.classList.contains('is-active') ? `${collapse_text.scrollHeight + 30}px` : 0 ;
		}
	})
})